import React, { Component } from 'react';
import { translate } from 'react-i18next';

class SuccessDialog extends Component {
  render() {
    const { t } = this.props;
    return(
      <div>
        <button
          className="hidden"
          data-target="#modalSuccess"
          data-toggle="modal"
          id="btnSuccess"
          type="button">
        </button>
        <div className="modal fade" id="modalSuccess" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h4>{t('dashboard.contact.heading_success')}</h4>
                <p>{t('dashboard.contact.success')}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-default"
                  data-dismiss="modal"
                  type="button">
                  {t('dashboard.contact.btn_success')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(SuccessDialog);



// WEBPACK FOOTER //
// ./src/dashboard/contact/SuccessDialog.js